import { useForm } from '@inertiajs/vue3'
import { UNLOCK_FULL_ACCESS_MODAL_NAME } from '@/shared/data/globalVariables.js'
import { notify } from '@kyvg/vue3-notification'
import { usePermissionSystem } from '@/shared/composables/usePermissionSystem.js'
import { useModals } from '@/shared/composables/useModals.js'
import { getUniqueId } from '@/shared/utils/uniqueId.js'

interface FormBodyType {
  challenge: string
  outcome: string
}

export const useMatchingForm = ({
  defaultValues,
}: {
  defaultValues?: FormBodyType
} = {}) => {
  const formId = `matching-form-${getUniqueId()}`
  const { isUserLoggedIn } = usePermissionSystem()
  const { openModal } = useModals()

  const matchingForm = useForm<FormBodyType>({
    challenge: defaultValues?.challenge || '',
    outcome: defaultValues?.outcome || '',
  })
  const SUCCESS_MESSAGE =
    'We are looking for suitable mentors for you. You will be notified when we find a match. (estimated time: 1-2 minutes)'

  const submitForm = ({
    url,
    method,
    transformator,
    onSuccess,
  }: {
    url: string
    method: 'POST' | 'PATCH'
    transformator?: (data: FormBodyType) => object
    onSuccess?: () => void
  }) => {
    if (!isUserLoggedIn.value) {
      return openModal(UNLOCK_FULL_ACCESS_MODAL_NAME)
    }

    matchingForm
      .transform(transformator || ((data) => data))
      [method.toLowerCase()](url, {
        preserveScroll: true,
        onSuccess: () => {
          matchingForm.reset()
          notify({
            type: 'success',
            text: SUCCESS_MESSAGE,
            duration: 8000,
          })
          onSuccess?.()
        },
        onError: (error) => {
          const errorMessage =
            error.challenge || error.outcome
              ? 'Please fill in all the fields.'
              : error || 'Something went wrong. Please try again.'
          notify({
            type: 'error',
            text: errorMessage,
          })
        },
      })
  }

  return {
    formId,
    matchingForm,
    submitForm,
    SUCCESS_MESSAGE,
  }
}
